import { render, staticRenderFns } from "./SearchBoxMultiple.vue?vue&type=template&id=24a80f0f&scoped=true&"
import script from "./SearchBoxMultiple.vue?vue&type=script&lang=js&"
export * from "./SearchBoxMultiple.vue?vue&type=script&lang=js&"
import style0 from "./SearchBoxMultiple.vue?vue&type=style&index=0&id=24a80f0f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a80f0f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAutocomplete,VIcon})
